// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"65cdf170","453":"8ab44547","905":"db222f00"}[chunkId] + ".chunk.js";
};